import { Component, For, Show } from "solid-js";
import { Modal, Button } from "../ui";
import type {
  ChangelogVersion,
  ChangeCategory,
} from "../../hooks/useChangelog";

export interface ChangelogModalProps {
  open: boolean;
  onClose: () => void;
  versions: ChangelogVersion[];
}

const categoryLabels: Record<ChangeCategory, string> = {
  new: "New",
  improved: "Improved",
  fixed: "Fixed",
};

const CATEGORY_CHIP =
  "bg-sunken text-ink-2 border-line font-mono uppercase text-2xs tracking-wide";

const categoryStyles: Record<ChangeCategory, string> = {
  new: CATEGORY_CHIP,
  improved: CATEGORY_CHIP,
  fixed: CATEGORY_CHIP,
};

function formatDate(iso: string): string {
  const date = new Date(iso + "T00:00:00");
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export const ChangelogModal: Component<ChangelogModalProps> = (props) => {
  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      title="What's New"
      size="lg"
      position="top"
    >
      <div class="space-y-6">
        <For each={props.versions}>
          {(version, index) => (
            <>
              <Show when={index() > 0}>
                <hr class="border-line" />
              </Show>
              <div>
                <div class="flex items-center justify-between mb-3">
                  <span class="text-base font-semibold text-ink">
                    v{version.version}
                  </span>
                  <span class="text-sm text-ink-3">
                    {formatDate(version.date)}
                  </span>
                </div>
                <ul class="space-y-2">
                  <For each={version.entries}>
                    {(entry) => (
                      <li class="flex items-start gap-2.5">
                        <span
                          class={
                            "inline-flex items-center shrink-0 mt-0.5 px-2 py-0.5 font-medium rounded-full border " +
                            categoryStyles[entry.category]
                          }
                          aria-label={categoryLabels[entry.category]}
                        >
                          {categoryLabels[entry.category]}
                        </span>
                        <span class="text-sm text-ink-2">{entry.text}</span>
                      </li>
                    )}
                  </For>
                </ul>
              </div>
            </>
          )}
        </For>
      </div>

      {/* Footer */}
      <div class="mt-6 pt-4 border-t border-line flex justify-end">
        <Button variant="primary" onClick={props.onClose}>
          Got it
        </Button>
      </div>
    </Modal>
  );
};
